export default {
  auth: {
    isAuthenticated: false,
    token: "",
    refreshToken: "",
    userInfo: null,
    loginHasErr: false,
    loginInProgress: false,
    tokenIsValid: null,
    pendingRefreshingToken: null,
    unAuth_Pending_Requests: [],
    changePasswordModal: false,
    version: "v4.0.0",
    language: "fa",
  },

  company: {
    currentCompany: {},
    projectList: [],
    currentProject: {},
  },

  tmw: {
    NewTeamWorkModal: false,
    addNewUserModal: false,
    addRuleModal: false,
    addProductGroupsModal: false,
    contractsList: [],
    contractsPager: {},
    selectedContract: null,
    teamWorks: [],
    teamWorksPager: {},
    usersList: [],
    usersPager: {},
    selectedUsers: [],

    selectedTeamWork: null,
    teamWorkInfo: [],

    nestedProductGroups: [], //nested  => [1,2,3,[4,5]]
    userProductGroups: [],
    selectedProductGroupsItems: [],
    selectedCurrentUser: null,
    currentTeamWorkId: 0,
    userAddedRules: [],

    currentTeamWork: {},
    WorkGroupsManagementModal: false,
    Loading: false,

    openDocumentGroup: false,
    openProductGroup: false,
    openOperationGroup: false,
  },

  sidebar: {
    activeNumber: 0,
    sidebarFixed: true,
    dispaySidebar: true,
  },

  dashboard: {
    dashboardCounters: null,
    NavTab: 1,
  },

  doc: {
    btnExportExcel: false,
    WaitingDocumentList: [],
    DocList: [],
    docGroup: [],
    isAddNewDoc: false,
    isEditDoc: false,
    filteringDocs: false,
    isFiltered: false,
    selectedDoc: {},
    isAddRevision: false,
    docInprogressList: [],
    selectedRev: {},
    activityList: [],
    selectedActivity: {},
    openTimesheetModal: false,
    openFinalizingModal: false,
    finalTemp: {},
    userList: [],
    selectedPendingRev: {},
    openPendingRevModal: false,
    openDocHistory: false,
    revEditModal: false,
  },

  trs: {
    waitingTrList: [],
    selectedPendTr: {},
    isEditDoclist: false,
    selectedRevList: [],
    regTrList: [],
    trSearch: false,
  },

  commentSheet: {
    comList: [],
    pendingComs: [],
  },
  tq: {
    tqList: [],
    pendingTq: [],
  },

  ncr: {
    ncrList: [],
    pendingNcr: [],
  },

  pr: {
    waitingMrpListForNewPR: [],
    waitingMrpForNewPrBadgeCount: 0,
    waitingMrpForConfirmPrBadgeCount: 0,
    AddNewMaterialsModal: false,
    ListofMaterials: [],
    MaterialsPager: {},
    selectedMaterials: [],

    waitingMrpListForConfirmPR: [],

    NoteModal: false,
    prNote: "",

    ConfirmRejectModal: false,
    isConfirm: false,

    defaultPr: {},
    PrDetailsInfo: [],
    PrDetailsPager: {},

    prList: [],
    ViewDocsModal: false,
    viewDocList: [],
  },

  rfp: {
    waitingRfpList: [],
    waitingRfpBadgeCount: 0,

    inProgressRfpList: [],
    inProgressRFPCount: 0,

    AddNewMaterialsModal: false,
    ListofMaterials: [],
    selectedMaterials: [],

    defaultRFP: {},
    RFPDetailsInfo: {},

    rfpList: [],

    rfpStatus: 0,

    isSupplierBtn: true,
    isSupplierCmp: false,
    AddNewSupplierModal: false,
    ListofSupplier: [],
    ListofSupplier2: [], //backup origin suppliers for local search
    selectedSuppliers: [],
    //-متن درخواست
    isActiveRequesText: false,

    //استعلام فنی
    technicalInquiry: false,
    technicalInquiryList: [],
    //استعلام بازرگانی
    businessInquiry: false,
    businessInquiryList: [],
    //جستجو
    advancedSearchFilter: false,
    // برای مودال مشاهده مدارک
    CurrentDoc: {},
    RevisionsLog: [],
    ViewDocsModal: false,
    viewDocList: [],
    //مهلت تحویل پروپوزال های
    ConfirmRejectModal: false,
    //pass to confirm modal
    parentFormValues: null,
    rfpInfo: {},
    //------
    EvaluationofProposalsList: [1, 2, 3],
    //-----مودال پروپوزال فنی-بازرگانی ----
    proposalModal: false,
    selectedSupplier: {},
    proposaltype: "",
    proposalArray: [],
    evaluationNote: "",
    evaluationScore: 0,
    inqueryType: 0,
    //------مودال استعلام فنی-بازرگانی ----
    InquiryModal: false,
    Inquirytype: "",
    inquiryList: [],

    //-----comment reply ----
    proposalComments: [],
    //- -------برنده - ------
    rfpEvaluations: [],
    WinnerModal: false,
  },

  op: {
    opList: [],
  },

  powerBi: {
    powerBiView: false,
  },

  inbox: {
    inboxModal: false,
    inboxBadge: 0,
    memberModal: false,
    postDetails: null,
  },

  ns: {
    nsModal: false,
    tab: 1,
  },
};
